<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ยอดเครดิตคงเหลือของสาขา</h1>
                    <p class="text-white pb-3 px-3">สามารถดูรายการยอดเครดิตคงเหลือของร้านค้าได้</p>
                </div>
                <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
                    <button class="btn btn-xl btn-warning px-4" @click="withDrawCredit.show = true">
                        <Icon icon="mdi-cash-multiple" v-bind:style="{fontSize: '20px'}"/>
                        ถอนเครดิต
                    </button>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-4">
                                    <label>ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)</label>
                                    <date-range-picker
                                        class="w-100"
                                        @start-selection="logEvent('startSelection', $event)"
                                        @finish-selection="logEvent('finishSelection', $event)"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :opens="'center'"
                                        :singleDatePicker="false"
                                        :appendToBody="true"
                                        :ranges="false"
                                        :closeOnEsc="false"
                                        :autoApply="true"
                                        :locale-data="{ format: 'dd-mm-yyyy' }"
                                        v-model="filters">
                                    </date-range-picker>
                                </div>
                                <div class="col-lg-8">
                                    <div class="row">
                                        <div class="col">
                                            <label>ค้นหาจากรหัสร้านค้า</label>
                                            <InputShopCode 
                                                :filter="search" 
                                                :addClass="'form-control'"
                                                :config="{ key : 'shop_code' , error : 'errorShopCode'}"
                                            />
                                        </div>
                                        <div class="col">
                                            <label>ค้นหาข้อมูลชื่อร้านค้า</label>
                                            <b-form-input v-model="search.shop_name" type="text" placeholder="ค้นหาข้อมูลชื่อร้านค้า"></b-form-input>
                                        </div>
                                        <div class="col">
                                            <label>ค้นหาชื่อเจ้าของร้าน</label>
                                            <b-form-input v-model="search.owner_name" type="text" placeholder="ค้นหาข้อมูลชื่อเจ้าของร้าน"></b-form-input>
                                        </div>
                                        <div class="form-group mb-0 pb-2">
                                            <label>&nbsp;</label>
                                            <div class="col-lg-3 d-flex align-items-end">
                                                <button class="btn btn-info btn-sm-res"
                                                    :disabled="checkErrorBeforeSearch"
                                                    @click="getCreditBalanceShop()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-12 d-flex justify-content-end">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel 
                                                :columns="columnsExcel" 
                                                :getData="getDataBranceExportExcel"
                                                name="ยอดเครดิตคงเหลือสาขา " 
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                :items="data"
                                :fields="fields"
                                :busy="busy"
                                class="scroll-bar-pop"
                                foot-clone
                                >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">
                                    {{((pagination.currentPage - 1) * pagination.perPage) + (data.index + 1) }}
                                </template>
                                <template slot="updated_at" slot-scope="row">
                                    {{ row.item.updated_at | dateFormat }}
                                </template>
                                <template slot="shop_code" slot-scope="row">
                                    {{( row.item.shop_code ) ? row.item.shop_code : '-'}}
                                </template>
                                <template slot="shop_name" slot-scope="row">
                                    {{( row.item.shop_name ) ? row.item.shop_name : '-'}}
                                </template>
                                <template slot="shop_owner_name" slot-scope="row">
                                    {{( row.item.shop_owner_name ) ? row.item.shop_owner_name : '-'}}
                                </template>
                                <template slot="freeze_status" slot-scope="data">
                                    <b-badge :variant="walletStatus(data.item.freeze_status).variant" >
                                        {{walletStatus(data.item.freeze_status).text}}
                                    </b-badge>
                                </template>
                                <template slot="range_latest_balance" slot-scope="row">
                                    {{row.item.range_latest_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_latest_peg_balance" slot-scope="row">
                                    {{row.item.range_latest_peg_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_latest_available_balance" slot-scope="row">
                                    {{row.item.range_latest_available_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="FOOT_index">รวม</template>
                                <template slot="FOOT_updated_at">&nbsp;</template>
                                <template slot="FOOT_dealer_id">&nbsp;</template>
                                <template slot="FOOT_shop_code">&nbsp;</template>
                                <template slot="FOOT_shop_name">&nbsp;</template>
                                <template slot="FOOT_shop_owner_name">&nbsp;</template>
                                <template slot="FOOT_freeze_status">&nbsp;</template>
                                <template slot="FOOT_peg_balance">
                                    {{footerTotal.peg_balance | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_available_balance">
                                    {{footerTotal.available_balance | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_balance">
                                    {{footerTotal.balance | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_range_latest_peg_balance">
                                    {{footerTotal.range_latest_peg_balance | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_range_latest_available_balance">
                                    {{footerTotal.range_latest_available_balance | numFormat('0,0.00')}}
                                </template>
                                <template slot="FOOT_range_latest_balance">
                                    {{footerTotal.range_latest_balance | numFormat('0,0.00')}}
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage" 
                                    @input="changePage"
                                    align="right" >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalWithDrawCredit :withDrawCredit="withDrawCredit" />
    </div>
</template>
<script>
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import ModalWithDrawCredit from '@/components/Modals/ModalWithDrawCredit'
import moment from "moment";
import InputShopCode from '@/components/custom/BaseInput/ShopCode'


export default {
    name: "historytopupwallettoshop",
    components:{
        ExportExcel,
        ModalWithDrawCredit,
        InputShopCode
    },
    data() {
        return {
            busy: true,
            data: [],
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            switchRoute: false,
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            search:{
                errorShopCode: false,
                shop_code: '',
                shop_name: '',
                owner_name: ''
            },
            withDrawCredit:{
                show: false
            },
            pagination:{
                currentPage: 1,
                perPage: 1,
                totalPage: 1,
                totalItem: 1
            }
        }
    },
    filters: {
        dateFormat(date) {
            const format = moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")
            return format !== 'Invalid date' ? format : date
        },
    },
    async mounted() {
        await this.creditBalanceShopAPI()
    },
    methods: {
        logEvent( event , date ){
            if( event == 'startSelection' ){
                this.minDate = moment(date, 'YYYY-MM-DD').add(-1, 'months').format("YYYY-MM-DD")
                this.maxDate =  moment(date, 'YYYY-MM-DD').add(1, 'months').format("YYYY-MM-DD")
                if( moment(date, 'YYYY-MM-DD').add(1, 'months').valueOf() > moment().valueOf() ){
                    this.maxDate = moment().format("YYYY-MM-DD");
                }
            }else if( event == 'finishSelection' ){
                this.minDate = null
                this.maxDate = moment().format("YYYY-MM-DD");
            }
        },
        getCreditBalanceShop(){
            this.creditBalanceShopAPI( this.search )
        },
        async creditBalanceShopAPI( search = null ){
            this.busy = true

            if(moment(this.filters.startDate).startOf('day').valueOf() == moment().startOf('day').valueOf()
               || moment(this.filters.endDate).startOf('day').valueOf() == moment().startOf('day').valueOf()
            ){
                this.switchRoute = true;
            }else{
                this.switchRoute = false;
            }

            let url = this.switchRoute
                ? "/wallet/agent/wallet/info" 
                : "/wallet/report/topBalanceSummary";
            await this.$http.get(
                this.$API_URL + url,
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                        date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                        page: this.pagination.currentPage,
                        filter: search
                    }
                }
                )
                .then(res => {
                    let result = res.data
                    if( result.status ){
                        this.data = result.data.data
                        this.pagination.perPage = result.data.per_page
                        this.pagination.currentPage = result.data.page
                        this.pagination.totalPage = result.data.total_page
                        this.pagination.totalItem = result.data.total_item
                    }
                })
                .catch(error => {
                    // do something pls
                })
            this.busy = false
        },
        async getDataBranceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                 let url = this.switchRoute
                            ? "/wallet/agent/wallet/info" 
                            : "/wallet/report/topBalanceSummary";
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + url,{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    filter: this.search,
                                    page: page++
                                }
                            }
                        )
                    ) 
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },
        walletStatus( status ){
            return !status 
            ? { variant: 'success', text: 'ใช้งาน' }
            : { variant: 'secondary', text: 'ปิดใช้งาน'}
        },
        async changePage(i){
            if (this.pagination.currentPage == i) return
            this.pagination.currentPage = i
            this.getCreditBalanceShop()
        },
    },
    computed: {
        checkErrorBeforeSearch(){
           return !!this.search.errorShopCode
        },
        fields(){ 
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "updated_at", field: "updated_at", label: "วันที่อัพเดตยอดเงินล่าสุด", sortable: true },
                { key: "dealer_id", field: "dealer_id", label: "รหัสตัวแทน", sortable: true },
                { key: "shop_code", field: "shop_code", label: "รหัสร้านค้า", sortable: true },
                { key: "shop_name", field: "shop_name", label: "ชื่อร้านค้า/สาขา", sortable: true },
                { key: "shop_owner_name", field: "shop_owner_name", label: "ชื่อเจ้าของร้าน", sortable: true },
                ...( this.switchRoute ) ? [
                    { key: "freeze_status", field: "freeze_status", label: "สถานะ", sortable: true },
                    { key: "peg_balance", field: "peg_balance", label: "เครดิตที่รอดำเนินการ", sortable: true },
                    { key: "available_balance", field: "available_balance", label: "ยอดเครดิตปัจจุบัน (บาท)", sortable: true },
                    { key: "balance", field: "balance", label: "ยอดเครดิตคงเหลือ (บาท)", sortable: true }
                ]:[
                    { key: "range_latest_peg_balance", field: "range_latest_peg_balance", label: "เครดิตที่รอดำเนินการ", sortable: true , class:"text-center" },
                    { key: "range_latest_available_balance", field: "range_latest_available_balance", label: "ยอดเครดิตปัจจุบัน (บาท)", sortable: true , class:"text-center" },  
                    { key: "range_latest_balance", field: "range_latest_balance", label: "ยอดเครดิตคงเหลือ (บาท)", sortable: true , class:"text-center" },
                ]
            ]
            return fields
        },
        columnsExcel(){
            let columns =  [
                { field: "updated_at", label: "วันที่อัพเดตยอดเงินล่าสุด"  },
                { field: "shop_code", label: "รหัสร้านค้า",
                    dataFormat: value => {
                        return (value) ? value : '-';
                    } 
                },
                { field: "shop_name", label: "ชื่อร้านค้า/สาขา",
                    dataFormat: value => {
                        return (value) ? value : '-';
                    }
                },
                { field: "shop_owner_name", label: "ชื่อเจ้าของร้าน" },
                { 
                    field: "freeze_status", 
                    label: "สถานะ",
                    dataFormat: value => {
                        return this.walletStatus( value ).text;
                    }
                },
                ...( this.switchRoute ) ? [
                    { field: "peg_balance", label: "เครดิตที่รอดำเนินการ" },
                    { field: "available_balance", label: "ยอดเครดิตปัจจุบัน (บาท)" },
                    { field: "balance", label: "ยอดเครดิตคงเหลือ (บาท)" }
                ]: [
                    { field: "range_latest_peg_balance", label: "เครดิตที่รอดำเนินการ", 
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                    { field: "range_latest_available_balance", label: "ยอดเครดิตปัจจุบัน (บาท)", 
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },  
                    { field: "range_latest_balance", label: "ยอดเครดิตคงเหลือ (บาท)",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                ]
                
            ]
            return columns
        },
        footerTotal(){
            let total = { peg_balance: 0, available_balance: 0, balance: 0, range_latest_peg_balance:0, range_latest_available_balance:0 ,range_latest_balance: 0 }
            this.data.forEach( item => {
                if(this.switchRoute){
                    total.peg_balance += +item.peg_balance
                    total.available_balance += +item.available_balance
                    total.balance += +item.balance
                }else{
                    total.range_latest_peg_balance += +item.range_latest_peg_balance
                    total.range_latest_available_balance += +item.range_latest_available_balance
                    total.range_latest_balance += +item.range_latest_balance
                }
            })
            return total
        }
    }
};
</script>